"use client";
import { useState as C, useEffect as b } from "react";
import { useInkeepConfig as _ } from "../providers/config-provider.js";
const a = "inkeepUsagePreferences", w = {
  hasSwitchModeButtonJiggled: !1,
  userId: null
}, k = {
  defaultView: null,
  inkeepChatSessionId: null
}, f = {
  ...w,
  ...k
}, d = {
  set(e, o, t, r = 365) {
    try {
      if (e === "cookie") {
        const s = /* @__PURE__ */ new Date();
        t === void 0 ? (s.setTime(s.getTime() - 1), document.cookie = `${a}_${o}=; expires=${s.toUTCString()}; path=/`) : (s.setTime(s.getTime() + r * 24 * 60 * 60 * 1e3), document.cookie = `${a}_${o}=${t}; expires=${s.toUTCString()}; path=/`);
      } else typeof sessionStorage < "u" && sessionStorage.setItem(`${a}_${o}`, t ? JSON.stringify(t) : "");
    } catch {
      return null;
    }
  },
  get(e, o) {
    if (e === "cookie") {
      const t = `${a}_${o}=`, r = document.cookie.split(";");
      for (const s of r) {
        const i = s.trim();
        if (i.startsWith(t))
          return i.substring(t.length);
      }
      return null;
    }
    try {
      if (typeof sessionStorage < "u") {
        const t = sessionStorage.getItem(`${a}_${o}`);
        return t ? JSON.parse(t) : null;
      }
    } catch {
      return null;
    }
    return null;
  }
}, U = () => {
  const { baseSettings: e, componentType: o } = _(), { optOutAllAnalytics: t, optOutFunctionalCookies: r } = e.privacyPreferences, i = !t && !r && B() ? "cookie" : "sessionStorage", p = `${e.apiKey}-${o}`, u = (n) => n in k ? `${n}-${p}` : n, S = Object.keys(f).reduce(
    (n, c) => {
      const l = u(c), g = d.get(i, l);
      return { ...n, [c]: g };
    },
    { ...f }
  ), [m, y] = C(S), $ = (n, c, l = 365) => {
    const g = u(n);
    d.set(i, g, c, l), y((h) => ({
      ...h,
      [n]: c
    }));
  };
  return b(() => {
    if (r)
      for (const n of Object.keys(f)) {
        const c = u(n);
        d.set("cookie", c, null, -1);
      }
  }, [r]), {
    browserStorage: m,
    setBrowserStorage: $
  };
}, I = () => {
  try {
    if (typeof localStorage > "u") return !1;
    const e = "__df709c5b-6651-43dc-94e7-d8dc899bf4e8__";
    return localStorage.setItem(e, "test_value"), localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}, T = () => {
  if (typeof document > "u") return !1;
  document.cookie = "testcookie=true; Path=/; Max-Age=1000";
  const e = document.cookie.includes("testcookie=true");
  return document.cookie = "testcookie=; Path=/; Max-Age=-1000", e;
}, B = () => {
  const e = I(), o = T();
  return e && o;
};
export {
  B as passesBrowserStorageChecks,
  U as useBrowserStorage
};
